import React from 'react';

const HomePage = () => {
  return (
    <div className="App">
      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-background">
          <div className="vector-animation">
            <div className="vector-shape shape-1"></div>
            <div className="vector-shape shape-2"></div>
            <div className="vector-shape shape-3"></div>
            <div className="vector-shape shape-4"></div>
            <div className="vector-shape shape-5"></div>
            <div className="vector-shape shape-6"></div>
            <div className="vector-shape shape-7"></div>
            <div className="vector-shape shape-8"></div>
            <div className="vector-shape shape-9"></div>
            <div className="vector-shape shape-10"></div>
            <div className="vector-shape shape-11"></div>
            <div className="vector-shape shape-12"></div>
            <div className="ripple ripple-1"></div>
            <div className="ripple ripple-2"></div>
            <div className="ripple ripple-3"></div>
            <div className="ripple ripple-4"></div>
            <div className="ripple ripple-5"></div>
          </div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-logo">
              <img src="/brickstone-logo.png" alt="Brickstone Studio" className="hero-logo-img" />
            </div>
            <h1 className="hero-title">Coming Soon</h1>
            <p className="hero-subtitle">
              A Media and Entertainment Company Founded by Ari Bradshaw
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <a href="#home">
                <img src="/brickstone-logo.png" alt="Brickstone Studio" />
              </a>
            </div>
            
            <div className="footer-copyright">
              <p>&copy; 2026 Brickstone Studio LLC. All rights reserved. Est. 2020</p>
              <div className="footer-legal">
                <a href="/privacy-policy.html" className="footer-legal-link">Privacy Policy</a>
                <span className="footer-legal-separator">•</span>
                <a href="/terms-conditions.html" className="footer-legal-link">Terms & Conditions</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage; 